angular.module('eStories.purchase.update', [

    'global.validation.model',
    'eStories.billing.model'

])
    .controller('UpdatePaymentDetailsCtrl', [
        'ModalsModel',
        'ValidationModel',
        '$uibModalInstance',
        'BillingModel',
        'AccountModel',
        '$rootScope',
        '$controller',
        '$scope',
        '$location',
        'LL',
        'GoogleModel',
        'GA',
        'PromoModel',
        '$cookies',
        'AffiliatesProgramModel',

        function (ModalsModel, ValidationModel, $uibModalInstance, BillingModel, AccountModel, $rootScope, $controller, $scope, $location, LL, GoogleModel, GA, PromoModel, $cookies, AffiliatesProgramModel) {

            var updatePaymentDetailsCtrl = this;
            var purchaseCtrl = $controller('PurchaseCtrl', {$scope: $scope});
            angular.extend(this, purchaseCtrl);

            updatePaymentDetailsCtrl.paypalButtonInitialized = false;
            updatePaymentDetailsCtrl.paypalChosen = false;
            updatePaymentDetailsCtrl.cvcClickToggle = false;

            updatePaymentDetailsCtrl.localyticsObject = {
                trialPlan: '',
                trialPeriod: 0,
                planSelected: '',
                planPeriod: 0,
                paymentType: '',
                optInMarketing: true,
                source: AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null,
                success: false
            };

            updatePaymentDetailsCtrl.shouldShowUKInfo = function () {
                if (eStoriesUserlocation) {
                    return eStoriesUserlocation.countryCode === "GB" || AccountModel.userDetails.countryCode === "GB";
                }
            };

            updatePaymentDetailsCtrl.getToggleStatus = function () {
                return updatePaymentDetailsCtrl.cvcClickToggle;
            };

            updatePaymentDetailsCtrl.resetPaymentForm = async function () {
                updatePaymentDetailsCtrl.paypalChosen = false;
                updatePaymentDetailsCtrl.paypalNonce = null;
                const response = await BillingModel.generateClientToken();
                if (response.responseStatus !== "SUCCESS") {
                    return;
                }
                updatePaymentDetailsCtrl.btClientToken = response.btGeneratedClientToken;
                updatePaymentDetailsCtrl.stClientToken = response.stGeneratedClientToken;
                angular.element('#updatePaymentDetailsPaypalContainer').html("");
                braintree.setup(updatePaymentDetailsCtrl.btClientToken, "paypal", {
                    container: 'updatePaymentDetailsPaypalContainer',
                    singleUse: false,
                    onReady: function () {
                        updatePaymentDetailsCtrl.paypalButtonInitialized = true;
                        safeApply($rootScope);
                    },
                    onPaymentMethodReceived: function (obj) {
                        updatePaymentDetailsCtrl.paypalChosen = true;
                        updatePaymentDetailsCtrl.paypalNonce = obj.nonce;
                        safeApply($rootScope);
                    },
                    onCancelled: function () {
                        updatePaymentDetailsCtrl.paypalChosen = false;
                        updatePaymentDetailsCtrl.paypalNonce = null;
                        safeApply($rootScope);
                    }
                });



                AccountModel.getLocation().then(function (response) {
                    const stripeKey = getStripePublicKey(response.country.currency);
                    updatePaymentDetailsCtrl.stripe = Stripe(stripeKey);

                    // Create an instance of Elements.
                    const elements = updatePaymentDetailsCtrl.stripe.elements();

                    // Custom styling can be passed to options when creating an Element.
                    const style = {
                        base: {
                            color: '#32325d',
                            lineHeight: '18px',
                            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                            fontSmoothing: 'antialiased',
                            fontSize: '16px',
                            '::placeholder': {
                                color: '#aab7c4'
                            }
                        },
                        invalid: {
                            color: '#fa755a',
                            iconColor: '#fa755a'
                        }
                    };

                    // Create an instance of the card Element.
                    updatePaymentDetailsCtrl.card = elements.create('card', {style: style});

                    // Add an instance of the card Element into the `card-element` <div>.
                    updatePaymentDetailsCtrl.card.mount('#card-element');

                    // Handle real-time validation errors from the card Element.
                    updatePaymentDetailsCtrl.card.addEventListener('change', event => {
                        updatePaymentDetailsCtrl.updatePaymentError = event.error ? event.error.message : null;
                        safeApply($scope);
                    });

                    // Handle form submission.
                    const form = document.getElementById('payment__form');
                    form.addEventListener('submit', async event => {
                        event.preventDefault();
                        await updatePaymentDetailsCtrl.submitUpdatePaymentDetails();
                    });
                });

            };

            if (AccountModel.isUserLoggedIn) {
                updatePaymentDetailsCtrl.resetPaymentForm();
            }

            updatePaymentDetailsCtrl.updateCardDetails = {};
            updatePaymentDetailsCtrl.updateCardDetailsFormErrors = {};
            updatePaymentDetailsCtrl.changePlan = function () {
//                return if user is getting a promo
                if (PromoModel.hasPlanPromo()) {
                    return;
                }
                AccountModel.setPendingPostChoosePlanAction(null);
                AccountModel.showChoosePlanModal();
            };

            updatePaymentDetailsCtrl.isTrialPurchase = function () {
                if (AccountModel.trialType === 'vipSignUp') {
                    updatePaymentDetailsCtrl.localyticsObject.trialPlan = "2_CREDIT_TRIAL"
                } else if (AccountModel.trialType === 'twoMo2cdt') {
                    updatePaymentDetailsCtrl.localyticsObject.trialPlan = "2_CREDIT_2_MONTH_TRIAL"
                } else {
                    updatePaymentDetailsCtrl.localyticsObject.trialPlan = "BASIC_TRIAL"
                }
                return AccountModel.pendingPlanPurchaseType === "BASIC_TRIAL";
            };

            updatePaymentDetailsCtrl.isPromoPurchase = function () {
                return AccountModel.pendingPlanPurchaseType === "PROMO";
            };

            updatePaymentDetailsCtrl.isGrouponPurchase = function () {
                return PromoModel.isGrouponPurchase;
            };

            updatePaymentDetailsCtrl.getHeaderText = function () {
                if (PromoModel.hasPlanPromo()) {
                    return "OFFER DETAILS";
                } else if (updatePaymentDetailsCtrl.isTrialPurchase() && !AccountModel.updateDetails && BillingModel.isPlanPurchase) {
                    //this BillingModel.isPlanPurchase is here so I can tell the  if a user is purchasing
                    //a trial or an alc book. Is important for the updatePaymentDetails.tmpl.html
                    return "FREE TRIAL DETAILS";
                } else if (!updatePaymentDetailsCtrl.isTrialPurchase() && !AccountModel.updateDetails) {
                    return "YOUR DETAILS";
                } else {
                    return "UPDATE DETAILS"
                }
            };

            updatePaymentDetailsCtrl.getPlanBillingCycleTimeUnits = function (plan) {
                switch (BillingModel.getPlanBillingCycleTimeUnits(plan)) {
                    case "MONTHLY":
                        return "month";
                    case "ANNUALLY":
                        return "year";
                    case "QUARTERLY":
                        return "quarter";
                    case "DAILY":
                        return "day";
                    default:
                        return "billing period";
                }
            };

            updatePaymentDetailsCtrl.getPromoPlan = function () {
                return PromoModel.promoPackage;
            };

            updatePaymentDetailsCtrl.getTrialPlan = function () {
                if (!updatePaymentDetailsCtrl.isTrialPurchase() || !updatePaymentDetailsCtrl.allPlansMap) {
                    return null;
                }
                var trialPlans = updatePaymentDetailsCtrl.allPlansMap["TRIAL"];
                if (!trialPlans) {
                    return null;
                }
                for (var i = 0; i < trialPlans.length; i++) {
                    var plan = trialPlans[i];
                    if (plan.planId == 333002000 && AccountModel.trialType == "vipSignUp") {
                        return plan;
                    } else if (plan.planId == 333001200 && AccountModel.trialType == "twoMo2cdt") {
                        return plan;
                    }
                }
                for (var i = 0; i < trialPlans.length; i++) {
                    var plan = trialPlans[i];
                    if (plan.planId == 333001000 && AccountModel.trialType != "vipSignUp") {
                        return plan;
                    }
                }
            };

            updatePaymentDetailsCtrl.isPlanPurchase = function () {
                if (!BillingModel.isPlanPurchase) {
                    return false;
                }
                return !!AccountModel.chosenPlan;
            };

            updatePaymentDetailsCtrl.shouldShowPaymentForm = function () {
                if (!updatePaymentDetailsCtrl.isPlanPurchase()) {
                    return true;
                }
                return updatePaymentDetailsCtrl.getSavedPaymentDetails() == null;
            };

            updatePaymentDetailsCtrl.getChosenVanityPromoPlan = function () {
                if (AccountModel.chosenVanityPromoPlan) {
                    return AccountModel.chosenVanityPromoPlan;
                } else {
                    return updatePaymentDetailsCtrl.getChosenPlan();
                }
            };

            updatePaymentDetailsCtrl.getChosenPlan = function (callbackFunc) {
                if (PromoModel.hasCreditPromo()) {
                    var monthlyPlans = updatePaymentDetailsCtrl.allPlansMap["MONTHLY"];
                    if (!monthlyPlans) {
                        return null;
                    }
                    for (var i = 0; i < monthlyPlans.length; i++) {
                        var plan = monthlyPlans[i];
                        if (plan.name == "Basic") {
                            AccountModel.setChosenPlan(plan);
                            return plan;
                        }
                    }
                }

                if (AccountModel.chosenPlan) {
                    return AccountModel.chosenPlan;
                }

                if (updatePaymentDetailsCtrl.allPlansMap == null) {
                    return null;
                }

                if (updatePaymentDetailsCtrl.isTrialPurchase()) {
                    var monthlyPlans = updatePaymentDetailsCtrl.allPlansMap["MONTHLY"];
                    if (!monthlyPlans) {
                        return null;
                    }
                    for (var i = 0; i < monthlyPlans.length; i++) {
                        var plan = monthlyPlans[i];
                        if (plan.name == "Basic") {
                            AccountModel.setChosenPlan(plan);
                            return plan;
                        }
                    }
                }

                if (updatePaymentDetailsCtrl.isPromoPurchase() && PromoModel.hasPlanPromo()) {
                    var allPlans = updatePaymentDetailsCtrl.allPlansMap;
                    if (!allPlans) {
                        return null;
                    }
//              iterates through allPlans (an obj of objs) and compares the planId of each plan to the planId of the promoPackage planId.
//              Doing this because it's dynamic (promos can be applied to any plan) as long as the planId sent inside the promoPackage is the
//              planId of a single plan it's to be applied to.
                    for (var key in allPlans) {
                        var obj = allPlans[key];
                        for (var prop in obj) {
                            if (obj[prop].planId == PromoModel.promoPackage.planId) {
                                AccountModel.setChosenPromoPlan(obj[prop]);
                                return obj[prop];
                            }
                        }
                    }

                }

                if (callbackFunc) {
                    callbackFunc();
                }

                return null;
            };

            updatePaymentDetailsCtrl.getChosenPlanFamily = function (familyName) {
                switch (familyName) {
                    case "MONTHLY":
                        return "monthly";
                    case "ANNUAL":
                        return "annually";
                    case "QUARTERLY":
                        return "quarterly";
                    default:
                        return "per billing period";
                }
            };

            updatePaymentDetailsCtrl.getChosenPlanCreditSubscriptionRenewalTimeAmount = function (planFamily) {
                switch (planFamily) {
                    case "MONTHLY":
                        return "a month";
                    case "ANNUAL":
                        return "a year";
                    case "QUARTERLY":
                        return "a quarter";
                    default:
                        return "per billing period";
                }
            };

            updatePaymentDetailsCtrl.displayUpdatePaymentError = function (code, prefixText, suffixText) {
                updatePaymentDetailsCtrl.updatePaymentError = prefixText ? prefixText + "<br/>" :
                    "Unable to save payment details<br/>";
                suffixText = suffixText ? suffixText : '';
                if (code) {
                    code = code.toLowerCase().replace(/_/g, " ").trim().replace(/(^[a-z])/g, function (a) {
                        return a.toUpperCase()
                    });
                    updatePaymentDetailsCtrl.updatePaymentError += "(" + code + ")" + suffixText;
                }
                safeApply($scope);
            };

            updatePaymentDetailsCtrl.displayPlanPurchaseError = function (code, prefixText, suffixText) {
                updatePaymentDetailsCtrl.updatePaymentError = prefixText ? prefixText + "<br/>" :
                    "Unable to purchase plan<br/>";
                suffixText = suffixText ? suffixText : '';

                if (code) {
                    switch (code) {
                        case "CREDIT_CARD_IS_SUBSCRIBED_FOR_TRIAL":
                            code = "It looks like you have already enjoyed an eStories trial offer. " +
                                "Please <a href='/plans' target='_blank'>pick a different plan</a> or <a href='https://emusic.zendesk.com/hc/en-us/requests/new' target='_blank'>contact eStories Customer Service</a>.";
                            updatePaymentDetailsCtrl.updatePaymentError += " (" + code + ")" + suffixText;
                            break;
                        default:
                            code = code.toLowerCase().replace(/_/g, " ").trim().replace(/(^[a-z])/g, function (a) {
                                return a.toUpperCase()
                            });
                            updatePaymentDetailsCtrl.updatePaymentError += " (" + code + ")" + suffixText;
                            break;
                    }
                }
                safeApply($scope);
            };

            updatePaymentDetailsCtrl.setInProgressFlag = function (inProgress) {
                updatePaymentDetailsCtrl.updatePaymentDetailsInProgress = inProgress;
                safeApply($scope);
            };

            updatePaymentDetailsCtrl.closePaymentModal = function () {
                $uibModalInstance.close();
            };

            updatePaymentDetailsCtrl.handlePurchasePromoResponse = function (plan, response) {
                if (response && response.responseStatus === 'SUCCESS') {
                    updatePaymentDetailsCtrl.handleSuccessfulPlanPurchased(response, function () {
                        updatePaymentDetailsCtrl.setInProgressFlag(false);
                        ModalsModel.open("/plans/postPromoPlanSignUpModal.tmpl.html", "PostPlanSignUpCtrl", "postPlanSignUpCtrl", "postPlanSignUpModal");
                        LL.tagSubscriptionPurchase(
                            plan,
                            AccountModel.getNextCreditRenewalDate(),
                            AccountModel.getNextBillingAttemptDate(),
                            AccountModel.getSubscriptionName(plan),
                            updatePaymentDetailsCtrl.paypalChosen ? "PayPal" : "Credit Card",
                            response,
                            PromoModel.promoPackage.marketingName,
                            PromoModel.promoPackage.discountCycles,
                            PromoModel.promoPackage.billingPromotionMarketingType,
                            AccountModel.calculateDiscountedPrice(AccountModel.getPlan().price, PromoModel.promoPackage.discountAmount, PromoModel.promoPackage.addOnAmount),
                            AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null
                        );
                        fbq('track', 'Purchase', {
                            content_type: 'product',
                            content_ids: ['00000'],
                            currency: plan.currency,
                            value: plan.price
                        });
                        GA.trackEvent('Purchase', 'Subscription Purchase', AccountModel.subscriptionDetails.subscription.plan.description, parseFloat(plan.price).toFixed(0));
                        PromoModel.clearPromoPackage();
                    });
                } else {
                    /* Failed */
                    updatePaymentDetailsCtrl.handlePlanPurchaseError(response.responseText)
                }
            };

            updatePaymentDetailsCtrl.handlePurchasePlan = async function () {
                var plan = updatePaymentDetailsCtrl.getChosenPlan();
                if (updatePaymentDetailsCtrl.isTrialPurchase()) {
                    var trialPlan = updatePaymentDetailsCtrl.getTrialPlan();
                    //TODO: make this more generic to support other units than days
                    updatePaymentDetailsCtrl.localyticsObject.trialPlan = trialPlan.name;
                    updatePaymentDetailsCtrl.localyticsObject.trialPeriod = trialPlan.billingCycleUnitAmount;
                    updatePaymentDetailsCtrl.localyticsObject.planSelected = plan.description;
                    updatePaymentDetailsCtrl.localyticsObject.planPeriod = plan.family;
                    let utmRequest = AffiliatesProgramModel.getUtmRequestObj();

                    const response = await BillingModel.purchaseTrial(plan.planPricingId, trialPlan.planPricingId, utmRequest);
                    if (response && response.responseStatus === 'SUCCESS') {
                        updatePaymentDetailsCtrl.handleSuccessfulPlanPurchased(response, function () {
                            updatePaymentDetailsCtrl.setInProgressFlag(false);
                            GoogleModel.trackConversion("gVKDCJ6f5mcQ_puwuQM", 0.01, plan.currency);
                            GA.trackEvent("Confirm Payment", "Registered User Completed Trial Account Setup")
                        });
                        updatePaymentDetailsCtrl.localyticsObject.success = true;
                        /*Localytics Trial Purchase*/
                        LL.tagTrialPurchase(updatePaymentDetailsCtrl.localyticsObject);
                        fbq('track', 'Purchase', {
                            content_type: 'product',
                            content_ids: ['00000'],
                            currency: plan.currency,
                            value: plan.price
                        });
                        ModalsModel.open("/plans/postPlanSignUpModal.tmpl.html", "PostPlanSignUpCtrl", "postPlanSignUpCtrl", "postPlanSignUpModal");

                    } else {
                        /* Failed */
                        updatePaymentDetailsCtrl.handlePlanPurchaseError(response.responseText)
                    }

                } else if (updatePaymentDetailsCtrl.isPromoPurchase()) {
                    var utmRequest = AffiliatesProgramModel.getUtmRequestObj();

                    if (PromoModel.promoPackage.name !== "GROUPON") {

                        if (AccountModel.chosenVanityPromoPlan && AccountModel.chosenVanityPromoPlan.planId === 333006000) {
                            const response = await BillingModel.purchasePromo(AccountModel.chosenVanityPromoPlan.planPricingId, PromoModel.promoCodeHash, utmRequest);
                            updatePaymentDetailsCtrl.handlePurchasePromoResponse(AccountModel.chosenVanityPromoPlan, response);
                        }
                        const response = await BillingModel.purchasePromo(plan.planPricingId, PromoModel.promoCodeHash, utmRequest);
                        updatePaymentDetailsCtrl.handlePurchasePromoResponse(plan, response);
                    } else if (PromoModel.promoPackage.name === "GROUPON") {
                        const response = await BillingModel.purchasePlan(plan.planPricingId, PromoModel.promoCodeHash, utmRequest);
                        if (response && response.responseStatus === 'SUCCESS') {
                            updatePaymentDetailsCtrl.handleSuccessfulPlanPurchased(response, function () {
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                                ModalsModel.open("/plans/postPromoPlanSignUpModal.tmpl.html", "PostPlanSignUpCtrl", "postPlanSignUpCtrl", "postPlanSignUpModal");
                                LL.tagSubscriptionPurchase(
                                    plan,
                                    AccountModel.getNextCreditRenewalDate(),
                                    AccountModel.getNextBillingAttemptDate(),
                                    AccountModel.getSubscriptionName(plan),
                                    updatePaymentDetailsCtrl.paypalChosen ? "PayPal" : "Credit Card",
                                    response,
                                    PromoModel.promoPackage.marketingName,
                                    null,
                                    "MEMBERSHIP_DISCOUNT",
                                    AccountModel.calculateDiscountedPrice(AccountModel.getPlan().price, PromoModel.promoPackage.discountAmount, PromoModel.promoPackage.addOnAmount),
                                    AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null
                                );
                                fbq('track', 'Purchase', {
                                    content_type: 'product',
                                    content_ids: ['00000'],
                                    currency: plan.currency,
                                    value: plan.price
                                });
                                GA.trackEvent('Purchase', 'Subscription Purchase', AccountModel.subscriptionDetails.subscription.plan.description, parseFloat(plan.price).toFixed(0));
                                PromoModel.promoPackage = null;
                            });
                        } else {
                            /* Failed */
                            updatePaymentDetailsCtrl.handlePlanPurchaseError(response.responseText)
                        }
                    }
                } else {
                    //TODO: make this more generic to support other units than days
                    updatePaymentDetailsCtrl.localyticsObject.planSelected = plan.description;
                    updatePaymentDetailsCtrl.localyticsObject.planPeriod = plan.billingCycleUnitAmount;

                    try {
                        const response = await BillingModel.purchasePlan(plan.planPricingId, null, utmRequest);
                        updatePaymentDetailsCtrl.handleSuccessfulPlanPurchased(response, function () {
                            /*Localytics Subscription Purchase*/
                            LL.tagSubscriptionPurchase(
                                plan,
                                AccountModel.getNextCreditRenewalDate(),
                                AccountModel.getNextBillingAttemptDate(),
                                AccountModel.getSubscriptionName,
                                updatePaymentDetailsCtrl.paypalChosen ? "PayPal" : "Credit Card",
                                response,
                                null,
                                null,
                                null,
                                AccountModel.getCurrentPlanPrice(),
                                AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null
                            );
                            fbq('track', 'Purchase', {
                                content_type: 'product',
                                content_ids: ['00000'],
                                currency: plan.currency,
                                value: plan.price
                            });
                            ModalsModel.open("/plans/postPlanSignUpModal.tmpl.html", "PostPlanSignUpCtrl", "postPlanSignUpCtrl", "postPlanSignUpModal");
                            GoogleModel.trackConversion("gVKDCJ6f5mcQ_puwuQM", parseFloat(plan.price), plan.currency);
                            GA.trackEvent('Purchase', 'Subscription Purchase', AccountModel.getSubscriptionName(), parseFloat(plan.price).toFixed(0));
                        });
                    } catch (error) {
                        updatePaymentDetailsCtrl.handlePlanPurchaseError(error);
                    }
                }


            };

            updatePaymentDetailsCtrl.handleSuccessfulPlanPurchased = function (planPurchaseResponse, successCallback, errorCallback) {
                updatePaymentDetailsCtrl.setInProgressFlag(false);
                safeDigest($scope);
                if (planPurchaseResponse.responseText === "SUCCESS") {
                    AffiliatesProgramModel.setPlanBoughtWithPromoFlag(AccountModel.chosenPlan.price);
                    $rootScope.$broadcast('refreshHomePageSections');
                    updatePaymentDetailsCtrl.localyticsObject.success = true;

                    AccountModel.resetPlanPurchaseProperties();
                    $uibModalInstance.close();
                    AccountModel.refreshSubscriptionDetails(function () {
                        if (successCallback) successCallback();
                        if ($location.path() === "/plans") {
                            $location.path("/browse");
                        }
                        if ($location.path().startsWith("/promo")) {
                            $location.path("/");
                        }
                    });
                    return;
                }

                switch (planPurchaseResponse.responseText) {
                    case "BILLING_ERROR":
                        updatePaymentDetailsCtrl.displayPlanPurchaseError(planPurchaseResponse.billingError,
                            'Oops, we can\'t processs your payment.  An error has occurred. ',
                            ' Please try again!');
                        break;
                    case "BILLING_PROVIDER_ERROR":
                        updatePaymentDetailsCtrl.displayPlanPurchaseError(planPurchaseResponse.billingError, 'We\'ve been notified of an error. ',
                            ' Please try again!');
                        break;
                    default:
                        updatePaymentDetailsCtrl.updatePaymentError = BillingModel.getPurchaseError(planPurchaseResponse.responseText);
                        break;
                }

                if (errorCallback) errorCallback();
            };

            updatePaymentDetailsCtrl.handlePlanPurchaseError = function (error) {
                updatePaymentDetailsCtrl.displayPlanPurchaseError(error);
                updatePaymentDetailsCtrl.setInProgressFlag(false);
                safeApply($scope);
            };

            updatePaymentDetailsCtrl.handleNonce = async function (nonce) {
                var paymentMethod = updatePaymentDetailsCtrl.paypalChosen ? "PAYPAL_ZERO" : "CREDIT_CARD_STRIPE";
                updatePaymentDetailsCtrl.localyticsObject.paymentType = paymentMethod;
                try {
                    const response = await BillingModel.savePaymentDetails(paymentMethod, nonce);
                    if (response.responseText === "SUCCESS") {
                        AccountModel.refreshSubscriptionDetails();
                        AccountModel.refreshSavedPaymentDetails();
                        // AccountModel.chosenPlan.planId == 333003000 means that it's the discounted extra credit promo
                        if (updatePaymentDetailsCtrl.isPlanPurchase() && AccountModel.chosenPlan.planId !== 333003000) {
                            updatePaymentDetailsCtrl.handlePurchasePlan();
                        } else if (purchaseCtrl.getPendingAudiobookPurchase() != null) {
                            purchaseCtrl.purchasePendingAudiobook(function () {
                                AccountModel.resetPendingAudiobookPurchase();
                                $location.path("/library");
                                $uibModalInstance.close();
                                safeDigest($scope);
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                            }, function (error) {
                                updatePaymentDetailsCtrl.updatePaymentError = error;
                                safeApply($scope);
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                            });
                        } else if (AccountModel.updateDetails) {
                            $uibModalInstance.close();
                            safeDigest($scope);
                        } else if ($location.path().indexOf('gift') > -1) {
                            AccountModel.refreshSavedPaymentDetails(function () {
                                $uibModalInstance.close();
                                AccountModel.openGiftRegistration();
                            });
                        }
                        return;
                    } else if (response.paymentMethodSaved) {
                        AccountModel.refreshSubscriptionDetails();
                        AccountModel.refreshSavedPaymentDetails();
                    }

                    if (updatePaymentDetailsCtrl.paypalChosen) {
                        updatePaymentDetailsCtrl.resetPaymentForm();
                    }

                    // Display an error if updatePaymentDetails not successful
                    updatePaymentDetailsCtrl.setInProgressFlag(false);
                    var preText = response.paymentMethodSaved ? "Payment details updated. " : null;
                    var suffixText = " Please try again.";
                    if (response.billingError) {
                        updatePaymentDetailsCtrl.displayUpdatePaymentError(response.billingError, preText, suffixText);
                        return;
                    }

                    switch (response.responseText) {
                        case 'BILLING_ERROR':
                            updatePaymentDetailsCtrl.displayUpdatePaymentError(response.responseText,
                                "Oops, we can't process your payment. An error has occurred: ", suffixText);
                            break;
                        case 'BILLING_PROVIDER_ERROR':
                            updatePaymentDetailsCtrl.displayUpdatePaymentError(response.responseText,
                                "We've been notified of an error: ", suffixText);
                            break;
                        default:
                            updatePaymentDetailsCtrl.updatePaymentError = BillingModel.getPaymentError(response.responseText);
                            break;
                    }
                } catch (error) {
                    updatePaymentDetailsCtrl.setInProgressFlag(false);
                    updatePaymentDetailsCtrl.displayUpdatePaymentError();
                    if (updatePaymentDetailsCtrl.paypalChosen) {
                        updatePaymentDetailsCtrl.resetPaymentForm();
                    }
                }
            };

            updatePaymentDetailsCtrl.openPromoTerms = function () {
                AccountModel.showPromoTermsModal();
            };

            updatePaymentDetailsCtrl.hasTerms = function () {
                if (PromoModel.promoPackage) {
                    return PromoModel.promoPackage.termsCopy != null;
                }
            };

            updatePaymentDetailsCtrl.showPlanChoiceDiscountCopy = function () {
                return (PromoModel.hasCreditPromo() || PromoModel.hasPlanPromo()) && PromoModel.promoPackage.name === "HALF_OFF_ANNUAL";
            };

            updatePaymentDetailsCtrl.changePlanMap = [];
            updatePaymentDetailsCtrl.changePlanMap['Lite'] = [];
            updatePaymentDetailsCtrl.changePlanMap['Lite']['Lite'] = 'none';
            updatePaymentDetailsCtrl.changePlanMap['Lite']['Basic'] = 'upgrade';
            updatePaymentDetailsCtrl.changePlanMap['Lite']['Plus'] = 'upgrade';
            updatePaymentDetailsCtrl.changePlanMap['Lite']['Premium'] = 'upgrade';

            updatePaymentDetailsCtrl.changePlanMap['Basic'] = [];
            updatePaymentDetailsCtrl.changePlanMap['Basic']['Lite'] = 'downgrade';
            updatePaymentDetailsCtrl.changePlanMap['Basic']['Basic'] = 'none';
            updatePaymentDetailsCtrl.changePlanMap['Basic']['Plus'] = 'upgrade';
            updatePaymentDetailsCtrl.changePlanMap['Basic']['Premium'] = 'upgrade';

            updatePaymentDetailsCtrl.changePlanMap['Plus'] = [];
            updatePaymentDetailsCtrl.changePlanMap['Plus']['Lite'] = 'downgrade';
            updatePaymentDetailsCtrl.changePlanMap['Plus']['Basic'] = 'downgrade';
            updatePaymentDetailsCtrl.changePlanMap['Plus']['Plus'] = 'none';
            updatePaymentDetailsCtrl.changePlanMap['Plus']['Premium'] = 'upgrade';

            updatePaymentDetailsCtrl.changePlanMap['Premium'] = [];
            updatePaymentDetailsCtrl.changePlanMap['Premium']['Lite'] = 'downgrade';
            updatePaymentDetailsCtrl.changePlanMap['Premium']['Basic'] = 'downgrade';
            updatePaymentDetailsCtrl.changePlanMap['Premium']['Plus'] = 'downgrade';
            updatePaymentDetailsCtrl.changePlanMap['Premium']['Premium'] = 'none';

            updatePaymentDetailsCtrl.submitUpdatePaymentDetails = async function () {
                // AccountModel.chosenPlan.planId == 333003000 means that it's the discounted extra credit promo
                if (!updatePaymentDetailsCtrl.agreeToU && updatePaymentDetailsCtrl.isPlanPurchase() && AccountModel.chosenPlan.planId !== 333003000) {
                    updatePaymentDetailsCtrl.updatePaymentError = 'Please accept terms & conditions';
                    return;
                }

                updatePaymentDetailsCtrl.updatePaymentError = null;
                safeApply($scope);
                updatePaymentDetailsCtrl.setInProgressFlag(true);
                // AccountModel.chosenPlan.planId == 333003000 means that it's the discounted extra credit promo
                if (updatePaymentDetailsCtrl.isPlanPurchase() && !updatePaymentDetailsCtrl.shouldShowPaymentForm() &&
                    AccountModel.chosenPlan.planId !== 333003000 && !updatePaymentDetailsCtrl.forceShowPaymentForm) {
                    if (AccountModel.isMember()) {
//                        AccountModel.chosenPlan.planId == 333003000 means that it's the discounted extra credit promo
                        if (PromoModel.hasPlanPromo() || PromoModel.hasCreditPromo()) {
                            var utmRequest = AffiliatesProgramModel.getUtmRequestObj();
                            try {
                                const response = await BillingModel.updatePlanImmediately(AccountModel.subscriptionDetails.subscription.id,
                                    AccountModel.chosenPlan.planPricingId, PromoModel.promoCodeHash, utmRequest);
                                if (response.responseStatus === "SUCCESS") {
                                    updatePaymentDetailsCtrl.closePaymentModal();
                                    AccountModel.refreshSubscriptionDetails(function () {
//                                  clears planId url parameters
                                        $location.search({});
                                        PromoModel.clearPromoPackage();
                                        $location.path("/browse");
                                        ModalsModel.open("/plans/postPromoPlanSignUpModal.tmpl.html", "PostPlanPurchaseCtrl", "postPlanPurchaseCtrl", "postPlanPurchaseModal");
                                    });
                                    return;
                                }
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                                updatePaymentDetailsCtrl.displayPlanPurchaseError("Could not update plan");
                            } catch (error) {
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                                updatePaymentDetailsCtrl.displayPlanPurchaseError("Could not update plan");
                            }
                        } else {
                            var oldPlan = AccountModel.subscriptionDetails.subscription.plan.name;
                            var newPlan = chosenPlan.name;
                            try {
                                const response = await BillingModel.updateConversionPlan(AccountModel.subscriptionDetails.subscription.id, AccountModel.chosenPlan.planPricingId, null);
                                if (response.responseStatus === "SUCCESS") {
                                    updatePaymentDetailsCtrl.closePaymentModal();
                                    LL.tagChangePlan(updatePaymentDetailsCtrl.changePlanMap[oldPlan][newPlan], oldPlan, newPlan, false);
                                    AccountModel.refreshSubscriptionDetails(function () {
//                                  clears planId url parameters
                                        $location.search({});
                                        $location.path("/browse");
                                        ModalsModel.open("/plans/postPlanPurchaseModal.tmpl.html", "PostPlanPurchaseCtrl", "postPlanPurchaseCtrl", "postPlanPurchaseModal");
                                    });
                                    return;
                                }
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                                updatePaymentDetailsCtrl.displayPlanPurchaseError("Could not update plan");
                            } catch (error) {
                                updatePaymentDetailsCtrl.setInProgressFlag(false);
                                updatePaymentDetailsCtrl.displayPlanPurchaseError("Could not update plan");
                            }
                        }
                    } else {
                        updatePaymentDetailsCtrl.handlePurchasePlan();
                        return;
                    }
                }
                if (updatePaymentDetailsCtrl.paypalChosen) {
                    updatePaymentDetailsCtrl.paypalButtonInitialized = false;
                    // Handle paypal
                    updatePaymentDetailsCtrl.handleNonce(updatePaymentDetailsCtrl.paypalNonce);
                } else {

                    var confirmCardSetupResult = await updatePaymentDetailsCtrl.stripe.confirmCardSetup(
                        updatePaymentDetailsCtrl.stClientToken,
                        {
                            payment_method: {
                                card: updatePaymentDetailsCtrl.card
                            }
                        }
                    );
                    if (confirmCardSetupResult.error) {
                        // Display error.message in your UI.
                        updatePaymentDetailsCtrl.updatePaymentError = confirmCardSetupResult.error.message;
                        safeApply($scope);
                        updatePaymentDetailsCtrl.setInProgressFlag(false);
                        return;
                    }
                    updatePaymentDetailsCtrl.handleNonce(confirmCardSetupResult.setupIntent.payment_method);
                }
            };

            updatePaymentDetailsCtrl.agreeToU = false;

            updatePaymentDetailsCtrl.allFieldsValid = function () {
                if (updatePaymentDetailsCtrl.paypalChosen) {
                    return true;
                }
                var creditCardValid = updatePaymentDetailsCtrl.validateCreditCardNumber(
                    updatePaymentDetailsCtrl.creditCardNumber);
                var expirationValid = updatePaymentDetailsCtrl.validateCreditCardExpiration(
                    updatePaymentDetailsCtrl.creditCardExpiration);
                var cvcValid = updatePaymentDetailsCtrl.validateCreditCardCvc(
                    updatePaymentDetailsCtrl.creditCardCvc);
                var zipValid = updatePaymentDetailsCtrl.validateCreditCardZip(
                    updatePaymentDetailsCtrl.creditCardZip);
                var promoValid = true;

                if (updatePaymentDetailsCtrl.shouldShowPromoInput) {
                    promoValid =
                        updatePaymentDetailsCtrl.validateCreditCardPromo(updatePaymentDetailsCtrl.creditCardPromo);
                }
                return creditCardValid && expirationValid && cvcValid && zipValid && promoValid;
            };

            updatePaymentDetailsCtrl.getConfirmButtonClass = function () {
                if (updatePaymentDetailsCtrl.shouldShowPaymentForm() && !updatePaymentDetailsCtrl.allFieldsValid()) {
                    return "disabled";
                }

                return "";
            };

            updatePaymentDetailsCtrl.getFieldClass = function (fieldName, fieldValue, isTypingInProgress) {
                return ValidationModel.getFieldClass(fieldName, fieldValue, updatePaymentDetailsCtrl.updateCardDetailsFormErrors,
                    isTypingInProgress);
            };

            updatePaymentDetailsCtrl.parseCreditCardNumber = function (creditCardNumber) {
                if (!creditCardNumber) {
                    return creditCardNumber;
                }
                return creditCardNumber.replace(/[^0-9]/g, "").replace(/(^[0-9]{19}).*/, "$1");
            };

            updatePaymentDetailsCtrl.validateCreditCardNumber = function () {
                return ValidationModel.validateCreditCardNumber(updatePaymentDetailsCtrl.creditCardNumber,
                    updatePaymentDetailsCtrl.updateCardDetailsFormErrors);
            };

            updatePaymentDetailsCtrl.validateCreditCardExpiration = function () {
                return ValidationModel.validateCreditCardExpiration(updatePaymentDetailsCtrl.creditCardExpiration,
                    updatePaymentDetailsCtrl.updateCardDetailsFormErrors);
            };

            updatePaymentDetailsCtrl.parseExpirationDate = function (expirationDate) {
                var parsedDate = updatePaymentDetailsCtrl.parseExpirationDateToOurFormat(expirationDate,
                    updatePaymentDetailsCtrl.previousExpirationDate);
                updatePaymentDetailsCtrl.previousExpirationDate = expirationDate;
                return parsedDate;
            };

            updatePaymentDetailsCtrl.parseExpirationDateToOurFormat = function (data, previousExpiry) {
                if (data == null) {
                    return "";
                }

                var shouldDeleteSecondMonthDigit = false;
                if (previousExpiry != null) {
                    if (previousExpiry.replace(/ \/ /g, " /") === data) {
                        shouldDeleteSecondMonthDigit = true;
                    }
                }

                data = data.replace(/[^0-9]/g, "");
                if (data == null || data === "") {
                    return "";
                }

                if (shouldDeleteSecondMonthDigit) {
                    data = data.replace(/([0-9])[0-9](.*)/g, "$1$2");
                }

                if (parseInt(data[0]) > 1) {
                    data = data.replace(/^(.*)/g, "0$1");
                }

                data = data.substr(0, 4);
                if (data.length >= 2) {
                    data = data.replace(/^(..)(.*)/g, "$1 / $2");
                }

                return data;
            };

            updatePaymentDetailsCtrl.parseCvc = function (cvc) {
                if (cvc == null) {
                    return cvc;
                }
                return cvc.replace(/[^0-9]/g, "").replace(/(^[0-9]{4}).*/, "$1");
            };

            updatePaymentDetailsCtrl.validateCreditCardCvc = function () {
                return ValidationModel.validateCreditCardCvc(updatePaymentDetailsCtrl.creditCardCvc,
                    updatePaymentDetailsCtrl.updateCardDetailsFormErrors);
            };

            updatePaymentDetailsCtrl.validateCreditCardZip = function () {
                return ValidationModel.validateCreditCardZip(updatePaymentDetailsCtrl.creditCardZip,
                    updatePaymentDetailsCtrl.updateCardDetailsFormErrors);
            };

            updatePaymentDetailsCtrl.validateCreditCardPromo = function () {
                return ValidationModel.validateCreditCardPromo(updatePaymentDetailsCtrl.creditCardPromo,
                    updatePaymentDetailsCtrl.updateCardDetailsFormErrors);
            };

            updatePaymentDetailsCtrl.getSubText = function () {
                if (updatePaymentDetailsCtrl.isAlcPurchase()) {
                    return "Buy for " + AccountModel.getPrice(updatePaymentDetailsCtrl.getAudiobook(), true);
                }
            };
        }]);
